import { render, staticRenderFns } from "./Typography7.vue?vue&type=template&id=598620ea&scoped=true"
import script from "./Typography7.vue?vue&type=script&lang=js"
export * from "./Typography7.vue?vue&type=script&lang=js"
import style0 from "./Typography7.vue?vue&type=style&index=0&id=598620ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598620ea",
  null
  
)

export default component.exports